module.exports = __webpack_public_path__ + "static/img/mebg_diamond.f90d861.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mebg_diamond.png
// module id = jlPu
// module chunks = 9